
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { UnitMemberData } from "./types";
import * as XLSX from 'xlsx';

interface ClosePerformanceCycleSectionProps {
  unitMembersData: UnitMemberData[];
  bandingYear: number;
}

const ClosePerformanceCycleSection = ({
  unitMembersData,
  bandingYear
}: ClosePerformanceCycleSectionProps) => {
  
  // Check if all unit members have completed final banding
  const isDownloadEnabled = unitMembersData.length > 0 && unitMembersData.every(member => {
    const hasFinalBanding = member.finalBanding && member.finalBanding !== '-' && member.finalBanding !== '';
    const hasValidStatus = member.status === 'Final Band Accepted' || 
                          member.status === 'Band disagreement resolution completed' ||
                          member.finalBanding === 'D'; // D band shows PIP badge
    return hasFinalBanding && hasValidStatus;
  });

  const handleDownloadExcel = () => {
    if (!isDownloadEnabled) return;

    // Prepare data for Excel export
    const excelData = unitMembersData.map((member, index) => ({
      'SN': index + 1,
      'Employee ID': member.id,
      'Team Member Name': member.full_name,
      'Self Rating': member.self_rating || member.averageSelfRating,
      'Manager Rating': member.manager_rating || member.averageManagerRating,
      'System Banding': member.allocatedPerformanceBand,
      'Final Banding': member.finalBanding,
      'Supervisor Comments': member.supervisorBandingComments || ''
    }));

    // Create workbook and worksheet
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(excelData);

    // Add worksheet to workbook
    const sheetName = `Final banding for ${bandingYear}`;
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    // Download the file
    const fileName = `Final_Banding_${bandingYear}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  };

  return (
    <Card className="bg-secondary border-primary border w-full">
      <CardHeader className="pb-3">
        <CardTitle className="text-white">Close Performance Cycle</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="text-white text-[12px]">
          The unit head can download the final performance banding as an Excel file, only if the final banding has been determined for everyone in the unit, including completing resolutions for all band disagreements.
        </p>
        <Button 
          onClick={handleDownloadExcel}
          disabled={!isDownloadEnabled}
          className="bg-primary text-black hover:bg-primary/90 disabled:opacity-50"
        >
          <Download className="mr-2 h-4 w-4" />
          Download Final Banding
        </Button>
      </CardContent>
    </Card>
  );
};

export default ClosePerformanceCycleSection;
